import React from 'react'

export default class OutState extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(e) {
    this.props.onChangeCallback(e.target.checked)
  }

  render() {

    let invoice = this.props.invoice

    let inputValue = typeof invoice.is_igst !== "undefined" ? invoice.is_igst : false

    let check = <div> <input type="checkbox" checked={inputValue} onChange={this.handleChange} /></div>

    return <div>{check}</div>
  }
}

export class AddCess extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(e) {
    this.props.onChangeCallback(e.target.checked)
  }

  render() {

    let invoice = this.props.invoice

    let inputValue = typeof invoice.add_cess !== "undefined" ? invoice.add_cess : false

    let check = <div> <input type="checkbox" checked={inputValue} onChange={this.handleChange} /></div>

    return <div>{check}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/outstate.js